// ag-grid-enterprise v21.2.2
"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

Object.defineProperty(exports, "__esModule", {
  value: true
});

var chart_1 = require("./chart");

var padding_1 = require("../util/padding");

var PolarChart =
/** @class */
function (_super) {
  __extends(PolarChart, _super);

  function PolarChart() {
    var _this = _super.call(this) || this;
    /**
     * The center of the polar series (for example, the center of a pie).
     * If the polar chart has multiple series, all of them will have their
     * center set to the same value as a result of the polar chart layout.
     * The center coordinates are not supposed to be set by the user.
     */


    _this.centerX = 0;
    _this.centerY = 0;
    /**
     * The maximum radius the series can use.
     * This value is set automatically as a result of the polar chart layout
     * and is not supposed to be set by the user.
     */

    _this.radius = 0;
    _this._padding = new padding_1.Padding(50);
    _this._series = [];

    _this.scene.root.append(_this.legend.group);

    return _this;
  }

  Object.defineProperty(PolarChart.prototype, "seriesRoot", {
    get: function get() {
      return this.scene.root;
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(PolarChart.prototype, "series", {
    get: function get() {
      return this._series;
    },
    set: function set(values) {
      var _this = this;

      this.removeAllSeries();
      values.forEach(function (series) {
        _this.addSeries(series, null);
      });
    },
    enumerable: true,
    configurable: true
  });

  PolarChart.prototype.performLayout = function () {
    var shrinkRect = {
      x: 0,
      y: 0,
      width: this.width,
      height: this.height
    };
    var captionAutoPadding = this.captionAutoPadding;
    shrinkRect.y += captionAutoPadding;
    shrinkRect.height -= captionAutoPadding;

    if (this.legend.enabled && this.legend.data.length) {
      var legendAutoPadding = this.legendAutoPadding;
      shrinkRect.x += legendAutoPadding.left;
      shrinkRect.y += legendAutoPadding.top;
      shrinkRect.width -= legendAutoPadding.left + legendAutoPadding.right;
      shrinkRect.height -= legendAutoPadding.top + legendAutoPadding.bottom;
      var legendPadding = this.legendPadding;

      switch (this.legendPosition) {
        case 'right':
          shrinkRect.width -= legendPadding;
          break;

        case 'bottom':
          shrinkRect.height -= legendPadding;
          break;

        case 'left':
          shrinkRect.x += legendPadding;
          shrinkRect.width -= legendPadding;
          break;

        case 'top':
          shrinkRect.y += legendPadding;
          shrinkRect.height -= legendPadding;
          break;
      }
    }

    var padding = this.padding;
    shrinkRect.x += padding.left;
    shrinkRect.y += padding.top;
    shrinkRect.width -= padding.left + padding.right;
    shrinkRect.height -= padding.top + padding.bottom;
    this.centerX = shrinkRect.x + shrinkRect.width / 2;
    this.centerY = shrinkRect.y + shrinkRect.height / 2;
    this.radius = Math.min(shrinkRect.width, shrinkRect.height) / 2;
    this.series.forEach(function (series) {
      series.update();
    });
    this.positionCaptions();
    this.positionLegend();
  };

  return PolarChart;
}(chart_1.Chart);

exports.PolarChart = PolarChart;